import React from "react";
import Card from "./Card";
import UploadClassWork from "./UploadClassWork";

export default function AllAssignment({
  assignments,
  navigateToAssignment,
  navigateToAddAssignment,
}) {
  return (
    <div className="p-2 my-4">
      <div>
        <h3 className="text-[18px] font-Nunito font-semibold text-[#141414] mb-2">
          All Assignments
        </h3>
        <p className="text-[#67748E] text-[14px]">Lorem ipsum dolor sit amet</p>
      </div>
      <div className="grid grid-cols-4 gap-0 my-6">
        {assignments.map((assignment, index) => (
          <Card
            key={index}
            {...assignment}
            navigateToAssignment={navigateToAssignment}
          />
        ))}
        <UploadClassWork navigateToAddAssignment={navigateToAddAssignment} />
      </div>
    </div>
  );
}
